<!-- TOP TOOLBAR
     *ngIf="isHandset$ | async"
     (click)="drawer.toggle()"
  -->

  <div class="card flex justify-content-center gap-2">
    <p-toast position="bottom-center"></p-toast>
  </div>

  <mat-toolbar *ngIf="isLogged()">
    <button
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="sidenavToggle(drawer)"
      (mouseover)="sidenavMouseOver=false"
      *ngIf="isLoggedAndActive()"
      >

      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
    </button>
    <!-- <span class="logo" routerLink="/">🔥 InternalizeIt</span> -->
    <img *ngIf="!isChromeExtension()" class="logo" routerLink="/" [src]="settingsService.getLogoPath()" style="max-height: 70px; margin: 15px 0 20px 10px;"/>
    <a *ngIf="isChromeExtension()" [href]="settingsService.getWebUrl()" target="_blank" style="height: 60px;" ><img class="logo" [src]="settingsService.getLogoPath()" style="max-height: 60px; margin: 0px 0 0px 10px;"/></a>


    <span class="fill-space"></span>
    <div *ngIf="false && !(breakPointService.isHandset$ | async) && !(breakPointService.isTablet$ | async)">
      <a mat-button routerLink="/kanban">🍱 Kanban Demo</a>
     <!-- <a mat-button routerLink="/customers">⚡ SSR Demo</a>-->
      <a mat-button routerLink="/local-images"> Local Images</a>
      <a mat-button routerLink="/notes"> Notes</a>
     <!-- <a mat-button routerLink="/notes/dyn"> Notes Dyn</a> -->
      <a mat-button routerLink="/notes/export"> Export to Mindmeister</a>

      <a mat-button routerLink="/login">🔑 Login</a>

    </div>

    <!-- DROPDOWN MENU -->

    <!--
    <button mat-button >
      <mat-icon class="profile-button-icon">person</mat-icon>
      <mat-icon class="profile-button-icon -ml-1">expand_more</mat-icon>
    </button>
  -->


  <button class="mr-2" *ngIf="isChromeExtension()" mat-icon-button [color]="chromeExtensionService.turnOn ? 'primary' : 'warn'"
       (click)="chromeExtensionService.turnON(!chromeExtensionService.turnOn)" [matTooltip]="chromeExtensionService.turnOn ? 'Note-taking is ON – Click to disable':'Note-taking is OFF – Click to enable'">
    <mat-icon class="mr-0">power_settings_new</mat-icon>
  </button>

  <button *ngIf="isLoggedAndActive() && !isChromeExtension()" mat-icon-button class="mr-2" color="primary" [matMenuTriggerFor]="menuLight">
    <mat-icon *ngIf="false"  class="mr-0">wb_sunny</mat-icon>
    <mat-icon  class="mr-0">{{getThemeIcon()}}</mat-icon>
  </button>

  <mat-menu #menuLight="matMenu" xPosition="before">
    <button mat-menu-item (click)="toggleTheme(ThemeType.LIGHT)">
      <mat-icon>wb_sunny</mat-icon>
      <span>Light</span>
    </button>
    <button mat-menu-item (click)="toggleTheme(ThemeType.DARK)">
      <mat-icon>nights_stay</mat-icon>
      <span>Dark</span>
    </button>
    <button mat-menu-item (click)="toggleTheme(ThemeType.SYSTEM)">
      <mat-icon>brightness_6</mat-icon>
      <span>System</span>
    </button>

  </mat-menu>


  <button mat-mini-fab class="" color="primary" [matMenuTriggerFor]="menuProfile">
    <mat-icon class="mr-0">person</mat-icon>
  </button>

  <mat-menu #menuProfile="matMenu">
    <button *ngIf="!isChromeExtension()" mat-menu-item routerLink="/account">
      <mat-icon>person</mat-icon>
      <span>Account Information</span>
    </button>
    <button *ngIf="false &&isLoggedAndActive() && !isChromeExtension()" mat-menu-item routerLink="/integrations">
      <mat-icon>apps</mat-icon>
      <span>Integrations</span>
    </button>
    <a mat-menu-item *ngIf="isChromeExtension()" [href]="settingsService.getWebUrl()" target="_blank">
      <mat-icon>launch</mat-icon>
      <span>Dashboard</span>
    </a>
    <button *ngIf="isLoggedAndActive()" mat-menu-item routerLink="/settings">
      <mat-icon>settings</mat-icon>
      <span>Settings</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>

  <!-- <mat-icon class="mr-0">expand_more</mat-icon> -->



    <!--
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <a mat-menu-item href="https://fireship.page.link/slack">
        <i>💬</i>
        <span>Chat on Slack</span>
      </a>
    </mat-menu>
  -->

  </mat-toolbar>

<mat-sidenav-container class="sidenav-container">
  <!-- SIDENAV
  [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
  [mode]="(isHandset$ | async) ? 'over' : 'side'"
   [opened]="false">
  -->

   <!-- SIDENAV -->

   <!--
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(breakPointService.isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(breakPointService.isHandset$ | async) ? 'over' : 'side'"
      [opened]="(breakPointService.isHandset$ | async) ? false:true"
      [ngStyle]="{'width': (breakPointService.sidenavExpanded || sidenavMouseOver ) ? '220px':'70px'}"
      (mouseover)="sidenavMouseOver=true"
      >
   -->

  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(breakPointService.isHandset || !isLoggedAndActive()) ? 'dialog' : 'navigation'"
      [mode]="(breakPointService.isHandset || !isLoggedAndActive()) ? 'over' : 'side'"
      [opened]="(breakPointService.isHandset || !isLoggedAndActive()) ? false:true"
      [ngStyle]="{'width': (breakPointService.sidenavExpanded || sidenavMouseOver ) ? '220px':'70px'}"
      (mouseover)="sidenavMouseOver=true"
      >
    <!--<mat-toolbar>Menu</mat-toolbar>-->
    <mat-nav-list>
     <!-- (click)="drawer.close()"  -->
      <a mat-list-item routerLink="/" (click)="settingsService.selectedMenu = 'home';  settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
          [ngStyle]="{'background-color': (settingsService.selectedMenu === 'home') ? getSelectedMenuColor():'inherit' }">
        <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Example home icon">home</mat-icon>
        <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Home</span>
      </a>

      <a mat-list-item routerLink="/insertion-point" (click)="settingsService.selectedMenu = 'insertionPoint';  settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
          [ngStyle]="{'background-color': (settingsService.selectedMenu === 'insertionPoint') ? getSelectedMenuColor():'inherit' }">
        <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Example home icon">gps_fixed</mat-icon>
        <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Select Location</span>
      </a>

    <!-- <div mat-list-item class="mat-list--expandable" [ngStyle]="{'background-color': (selected === 'notebooks') ? getSelectedMenuColor():'inherit' }"> -->
      <!-- <mat-icon style=" vertical-align: middle; margin-right: 2px">chevron_right</mat-icon> -->
      <a mat-list-item routerLink="/notebooks" (click)="settingsService.selectedMenu = 'notebooks'; settingsService.reviewsTabActive = false; handleMenuClick(drawer)" [ngStyle]="{'background-color': (settingsService.selectedMenu === 'notebooks') ? getSelectedMenuColor():'inherit' }">
        <mat-icon style=" vertical-align: middle;"  aria-hidden="false" aria-label="Example home icon">library_books</mat-icon>
        <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Notebooks</span>
      </a>
    <!-- </div> -->

    <!--
    <a mat-list-item routerLink="/reviews" (click)="selected = 'pendingReviews'"
          [ngStyle]="{'background-color': (selected === 'pendingReviews') ? getSelectedMenuColor():'inherit' }">
        <mat-icon aria-hidden="false" aria-label="Example home icon">timer</mat-icon>
        <span *ngIf="sidenavExpanded || sidenavMouseOver">Pending Reviews</span>
    </a>
  -->


    <div mat-list-item class="mat-list--expandable" routerLink="/reviews" (click)="settingsService.selectedMenu = 'reviews'; settingsService.reviewsTabActive = true"
          [ngStyle]="{'background-color': (settingsService.reviewsTabActive) ? getSelectedMenuColor():'inherit' }" *ngIf="!isChromeExtension() || true">
        <mat-icon *ngIf="!settingsService.reviewsTabActive" aria-hidden="false" style=" vertical-align: middle; margin-right: 0px" >chevron_right</mat-icon>
        <mat-icon *ngIf="settingsService.reviewsTabActive"  aria-hidden="false" style=" vertical-align: middle; margin-right: 0px" >expand_more</mat-icon>
        <mat-icon aria-hidden="false" aria-label="Example home icon" style="vertical-align: middle; margin-left: -2px;">restore</mat-icon>
        <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Reviews </span>
    </div>

    <div mat-list-item class="mat-list--expandable pl-5" *ngIf="settingsService.reviewsTabActive && (!isChromeExtension() || true)" routerLink="/reviews/pending" (click)="settingsService.selectedMenu = 'pendingReviews'; handleMenuClick(drawer)"
          [ngStyle]="{'background-color': (settingsService.selectedMenu === 'pendingReviews') ? getSelectedMenuColor():'inherit' }">
        <mat-icon aria-hidden="false" aria-label="Example home icon" style="vertical-align: middle;">assignment</mat-icon>
        <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Pending Reviews</span>
    </div>

    <div mat-list-item class="mat-list--expandable pl-5" *ngIf="settingsService.reviewsTabActive && (!isChromeExtension() || true)" routerLink="/reviews/completed" [queryParams]="queryDoneReviews" (click)="settingsService.selectedMenu = 'doneReviews'; handleMenuClick(drawer)"
          [ngStyle]="{'background-color': (settingsService.selectedMenu === 'doneReviews') ? getSelectedMenuColor():'inherit' }">
        <mat-icon aria-hidden="false" aria-label="Example home icon" style="vertical-align: middle;">assignment_turned_in</mat-icon>
        <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Completed Reviews</span>
    </div>

    <div mat-list-item class="mat-list--expandable pl-5" *ngIf="settingsService.reviewsTabActive && (!isChromeExtension() || true)" routerLink="/reviews/create" (click)="settingsService.selectedMenu = 'createReview'; handleMenuClick(drawer)"
          [ngStyle]="{'background-color': (settingsService.selectedMenu === 'createReview') ? getSelectedMenuColor():'inherit' }">
        <mat-icon aria-hidden="false" aria-label="Example home icon" style="vertical-align: middle;">add_alarm</mat-icon>
        <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Create Review</span>
  </div>


   <!--
    <a mat-list-item [matMenuTriggerFor]="reviews">ReviewsM</a>
    <mat-menu #reviews="matMenu">
      <button mat-menu-item >Pending Reviews</button>
      <button mat-menu-item >Done Reviews</button>
      <button mat-menu-item >Create Review</button>
    </mat-menu>
  -->

  <!--
    <a mat-list-item  (click)="selected = 'mindmeister';  reviewsTabActive = false; handleMenuClick(drawer)"
          [ngStyle]="{'background-color': (selected === 'mindmeister') ? getSelectedMenuColor():'inherit' }">
        <mat-icon aria-hidden="false" aria-label="Example home icon">sync</mat-icon>
        <span *ngIf="sidenavExpanded || sidenavMouseOver">  Import and Sync</span>
      </a>

      <a mat-list-item routerLink="/export" (click)="selected = 'export';  reviewsTabActive = false; handleMenuClick(drawer)"
          [ngStyle]="{'background-color': (selected === 'export') ? getSelectedMenuColor():'inherit' }">
        <mat-icon aria-hidden="false" aria-label="Example home icon">cloud_upload</mat-icon>
        <span *ngIf="sidenavExpanded || sidenavMouseOver">  Export</span>
      </a>
  -->

    <a mat-list-item routerLink="/integrations" (click)="settingsService.selectedMenu = 'Integrations';  settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
      [ngStyle]="{'background-color': (settingsService.selectedMenu === 'Integrations') ? getSelectedMenuColor():'inherit' }" *ngIf="false && !isChromeExtension()">
      <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Example home icon">apps</mat-icon>
      <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Integrations</span>
    </a>


      <a mat-list-item routerLink="/settings" (click)="settingsService.selectedMenu = 'settings';  settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
      [ngStyle]="{'background-color': (settingsService.selectedMenu === 'settings') ? getSelectedMenuColor():'inherit' }">
      <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Example home icon">settings</mat-icon>
      <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Settings</span>
    </a>

    <a mat-list-item href="https://chromewebstore.google.com/detail/ddomkgcejkkdjahignocomhieggjfhba" target="_blank"
      (click)="settingsService.selectedMenu = 'extension';  settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
      [ngStyle]="{'background-color': (settingsService.selectedMenu === 'extension') ? getSelectedMenuColor():'inherit' }"
      *ngIf="!breakPointService.isHandset && !isChromeExtension()">
      <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Example home icon">extension</mat-icon>
      <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Crome Extension</span>
    </a>

    <a mat-list-item href="https://internalizeit.com/docs/" target="_blank"
      (click)="settingsService.selectedMenu = 'documentation';  settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
      [ngStyle]="{'background-color': (settingsService.selectedMenu === 'documentation') ? getSelectedMenuColor():'inherit' }">
      <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Example home icon">help</mat-icon>
      <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Documentation</span>
    </a>

    <a mat-list-item routerLink="/learning-toolkit" *ngIf="!isChromeExtension()"
      (click)="settingsService.selectedMenu = 'learningToolkit'; settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
      [ngStyle]="{'background-color': (settingsService.selectedMenu === 'learningToolkit') ? getSelectedMenuColor():'inherit' }">
      <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Learning Toolkit">school</mat-icon>
      <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Learning Toolkit</span>
    </a>

    <a mat-list-item href="https://internalizeit.com/feedback/" target="_blank"
      (click)="settingsService.selectedMenu = 'feedback';  settingsService.reviewsTabActive = false; handleMenuClick(drawer)"
      [ngStyle]="{'background-color': (settingsService.selectedMenu === 'feedback') ? getSelectedMenuColor():'inherit' }">
      <mat-icon style=" vertical-align: middle;" aria-hidden="false" aria-label="Example home icon">feedback</mat-icon>
      <span *ngIf="breakPointService.sidenavExpanded || sidenavMouseOver">Feedback</span>
    </a>

    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content [ngStyle]="{'margin-left': breakPointService.sidenavExpanded ? '220px':'80px'}"
      (mouseover)="sidenavMouseOver=false" click>

    <!-- TRANSCLUSION -->

    <ng-content> </ng-content>


  </mat-sidenav-content>
</mat-sidenav-container>
